module.exports = __webpack_public_path__ + "img/bonus_symbol_3.fe3f14f5.png";